import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { PromocaoListComp } from 'pages/revendedor/promocao/components';

export function PromocaoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['REVENDEDOR_CADASTRO_PROMOCAO'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <PromocaoListComp />
        </ListagemProvider>
    );
}
